import { Component, OnInit } from '@angular/core';

import { LoadService } from '@asambleas-components/loader/loader.service';
import { IglesiasService } from '@asambleas-services/iglesias/iglesias.service';
import { RegistrationService } from '@asambleas-services/registration/registration.service';

import { District } from '@asambleas-models/district.model';
import { Sectional } from '@asambleas-models/sectional.model';
import { Church } from '@asambleas-models/church.model';
import { Router } from '@angular/router';
import { CitiesService } from '@asambleas-services/cities/cities.service';
import { City } from '@asambleas-models/City.model';
import { FormControl } from '@angular/forms';

import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
    selector: 'app-mapa-iglesias',
    templateUrl: './mapa-iglesias.component.html',
    styleUrls: ['./mapa-iglesias.component.css']
})
export class MapaIglesiasComponent implements OnInit {

    churches: any[] = [];

    latitude: number = null;
    length: number = null;
    centreMarker: string = 'Ubicación actual';

    districts: District[] = [];
    sectionals: Sectional[] = [];
    cities: City[] = [];
    citySelected: any = null;

    loading: boolean = true;
    loader: any;

    cameFromLogin: boolean = false;

    timer;
    TIME_INTERVAL = 1000;
    myControl = new FormControl();
    filteredOptions: Observable<City[]>;
    searchTerm: string = null;

    constructor(private _churchesService: IglesiasService,
        private registrationService: RegistrationService,
        private loadService: LoadService,
        private _citiesService: CitiesService,
        private router: Router
    ) { }

    ngOnInit() {
        this.currentPosition();
        this.getAllChurches();

        if (this.router.url == '/mapa') {
            console.log('Viene desde login');
            this.cameFromLogin = true;
        }

        this.registrationService.getDistricts()
            .subscribe((data: District[]) => {
                this.districts = data;
            })

        this._citiesService.getAllCities()
            .subscribe((data: City[]) => {
                this.cities = data;

                this.filteredOptions = this.myControl.valueChanges
                    .pipe(
                        startWith(''),
                        map(value => this._filter(value))
                    );
            })



    }

    getAllChurches() {

        this.loader = this.loadService.createLoad('');
        this.loader.open();

        this._churchesService.getAllChurches()
            .subscribe((data: Church[]) => {

                //console.log(data);

                this.churches = data;

                this._churchesService.allChurches = data;

                this.formatCoords();

                this.loader.close();

            }, () => {
                console.log('Hubo un error');
                this.loader.close();
            })
    }

    currentPosition() {

        this.latitude = null;
        this.length = null;

        navigator.geolocation.getCurrentPosition((position) => {
            this.latitude = position.coords.latitude;
            this.length = position.coords.longitude;
        });
    }

    setCenterPosition(latitude: number, length: number, nombre: string) {

        this.centreMarker = nombre;

        this.latitude = Number(latitude);
        this.length = Number(length);

    }

    getChurchesByName(value: string) {
        clearInterval(this.timer);
        this.timer = setTimeout(() => {

            this.loader = this.loadService.createLoad('');
            this.loader.open();

            this._churchesService.getChurchesByTerm(this.searchTerm)
                .then((data: Church[]) => {
                    this.churches = data;

                    this.formatCoords();

                    this.loader.close();
                })
                .catch(() => {
                    console.log('Hubo un error');
                    this.loader.close();
                })

        }, this.TIME_INTERVAL);
    }

    // Casting to church coords, String to Number
    formatCoords() {

        for (let i = 0; i < this.churches.length; i++) {
            this.churches[i].latitude = Number(this.churches[i].latitude);
            this.churches[i].length = Number(this.churches[i].length);
        }


    }

    changeDistrict(districtValue) {

        this.loader = this.loadService.createLoad('');
        this.loader.open();

        this._churchesService.getChurchesByDistrict(districtValue)
            .then((data: any) => {
                this.churches = data;
                this.formatCoords();

                this.loader.close();
            })
            .catch(() => {
                console.log('Hubo un error');
                this.loader.close();
            })

        if (districtValue !== undefined && districtValue !== null) {
            if (districtValue > 0) {

                this.registrationService.getDistrictDataById(districtValue)
                    .subscribe((districtData: any) => {

                        this.sectionals = districtData.sectionals
                        this.cities = [];

                    });
            }
        }


    }

    changeSectional(sectionalValue) {

        this.loader = this.loadService.createLoad('');
        this.loader.open();

        this._churchesService.getChurchesBySectional(sectionalValue)
            .then((data: any) => {
                this.churches = data;
                this.formatCoords();

                this.loader.close();
            })
            .catch(() => {
                console.log('Hubo un error');
                this.loader.close();
            })

        this.registrationService.getSectionalDataById(sectionalValue)
            .subscribe((data: any) => {
                console.log(data)
                this.cities = data.cities;
            }, () => {
                console.log('Hubo un error');
            })

    }

    changeCity(cityValue = null) {
        if (this.citySelected === '') {
            this.getAllChurches();
            return;
        }

        if (!this.citySelected || !this.citySelected.id) {
            //this.churches.length = 0;
            return;
        }

        this.loader = this.loadService.createLoad('');
        this.loader.open();

        this._churchesService.getChurchesByCity(this.citySelected.id)
            .then((data: any) => {
                this.churches = data;
                this.formatCoords();

                this.loader.close();
            })
            .catch(() => {
                console.log('Hubo un error');
                this.loader.close();
            })
    }

    clearFilters() {
        //this.districts = [];
        this.sectionals = [];
        this.searchTerm = null;
        this.citySelected = null;
        //this.cities = [];

        this.getAllChurches();
    }

    goBack() {
        this.router.navigate(['/']);
    }

    displayFn(city?: City): string | undefined {
        return city ? city.name : undefined;
    }

    private _filter(value): City[] {
        let filterValue = '';

        /* if (typeof value === 'string') {
            filterValue = value.toLowerCase();
        } else {
            filterValue = value.name.toLowerCase();
        } */

        if (value && typeof value === 'object') {
            filterValue = value.name.toLowerCase();
        }
        else if (value && typeof value === 'string') {
            filterValue = value.toLowerCase();
        }

        return this.cities.filter(city => city.name.toLowerCase().includes(filterValue));
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/pages/iglesias/mapa-iglesias/mapa-iglesias.component.ts